import { AiOutlineArrowRight, AiOutlineInstagram } from "react-icons/ai";
import { SiAdobe } from "react-icons/si";
import ProfileImage from "../images/nathancolesjr.png";
import { allWorkVideos } from "../data/videos";
import Portfolio from "./Portfolio";

const breakdownVideos = [
  {
    title: "Anti-Boring Edit Pacing",
    description: "How I take a stale draft edit and turn it into something that gets you hyped.",
    mediaUrl: "/media/director/swag_intro_editing_breakdown.mp4",
  },
  {
    title: "Premiere Pro vs After Effects",
    meta: "Collaboration with Adobe",
    metaLogo: "adobe",
    description: "Breaking down the difference between Adobe's two main video editing programs and how I use them together to make better videos.",
    mediaUrl: "/media/business/aftereffects_vs_premiere_ex.mp4",
  },
  {
    title: "Green-Screen Environment Replacement Breakdown",
    description: "How I use green-screen footage and environment replacement to create a more engaging video.",
    mediaUrl: "/media/business/nathancolesjr_portfolio_talkinghead.mp4",
  },
];

const editingWorkVideos = allWorkVideos.slice(
  0,
  allWorkVideos.findIndex((item) => item.name === "Will Metty & Doxycodone - Slide Thru") + 1
);

function EditingPage() {
  return (
    <main className="pageMain editingPage">
      <section className="section editingHero">
        <div className="editingHero__layout">
          <div className="editingHero__content">
            <div className="editingHero__portraitWrap" aria-hidden="true">
              <div className="editingHero__portraitGlow" />
              <img className="editingHero__portrait" src={ProfileImage} alt="" />
            </div>
            <h1>I Edit Videos People Keep Watching</h1>
            <p>
              Long-form and short-form editing focused on pacing, story clarity, music, sound design, visual support, and fast improvements from notes.
            </p>
            <div className="editingHero__actionGroup">
              <a
                className="editingHero__instagram"
                href="https://www.instagram.com/nathancolesjr/"
                target="_blank"
                rel="noreferrer"
              >
                <AiOutlineInstagram aria-hidden="true" />
                <span>My Instagram</span>
              </a>
              <div className="editingHero__actions">
                <a className="button button--primary" href="#editing-breakdowns">
                  View Editing Breakdowns
                </a>
                <a className="button button--secondary" href="#my-work">
                  View Work
                </a>
              </div>
            </div>
          </div>

          <div className="editingHero__visual editingHero__visual--vertical">
            {/* Replace this with your editing breakdown preview when ready. */}
            <video className="editingHero__video" autoPlay muted loop playsInline preload="metadata">
              <source src="/media/director/Edit_Hero.mp4" />
            </video>
          </div>
        </div>
      </section>

      <Portfolio
        id="my-work"
        title="My work"
        intro="Music videos, trailers, creator-led content, promos, and other finished edits."
        videos={editingWorkVideos}
      />

      <section className="section editingSection" id="editing-breakdowns">
        <div className="sectionHeading">
          <h2>Editing Breakdowns</h2>
          <p>Examples that show how I think through the edit, not just the final export.</p>
        </div>

        <div className="editingBreakdownGrid">
          {breakdownVideos.map((item) => (
            <article key={item.title} className="editingBreakdownCard">
              <div className="editingBreakdownCard__media editingBreakdownCard__media--vertical">
                {/* Replace these local sources with your actual breakdown videos when ready. */}
                <video className="editingProjectCard__video" controls playsInline preload="metadata">
                  <source src={item.mediaUrl} />
                </video>
              </div>
              <div className="editingBreakdownCard__copy">
                <h3>{item.title}</h3>
                {item.meta ? (
                  <p className="editingBreakdownCard__meta">
                    <span>{item.meta}</span>
                    {item.metaLogo === "adobe" ? <SiAdobe className="editingBreakdownCard__metaLogo--adobe" aria-hidden="true" /> : null}
                  </p>
                ) : null}
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="editingSection__actions">
          <a className="editingSection__instagram" href="https://www.instagram.com/nathancolesjr/" target="_blank" rel="noreferrer">
            <AiOutlineInstagram aria-hidden="true" />
            <span>See More</span>
            <AiOutlineArrowRight aria-hidden="true" />
          </a>
        </div>
      </section>
    </main>
  );
}

export default EditingPage;
